<template>
  <div id="app-root">
    <IsometricNav>
      <template #actions>
        <LanguageSwitcher />
      </template>
    </IsometricNav>
    <router-view v-slot="{ Component }">
      <transition name="iso-page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <footer class="site-footer">
      <div class="iso-container footer-inner">
        <span class="footer-copy">&copy; {{ year }} {{ $t('site.name') }}. {{ $t('common.copyright') }}</span>
        <router-link to="/feedback" class="footer-link">{{ $t('nav.feedback') }}</router-link>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import IsometricNav from '@/components/IsometricNav.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

const year = new Date().getFullYear()
</script>

<style scoped>
#app-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.site-footer {
  margin-top: auto;
  padding: 24px 0;
  border-top: 1px solid var(--iso-border);
  background: rgba(10, 14, 26, 0.6);
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.footer-copy {
  font-size: 13px;
  color: var(--iso-text-dim);
}

.footer-link {
  font-size: 13px;
  color: var(--iso-text-dim);
  transition: color 0.2s;
}

.footer-link:hover {
  color: var(--iso-cyan);
}

.iso-page-enter-active {
  animation: iso-fade-in 0.3s ease-out;
}

.iso-page-leave-active {
  animation: iso-fade-in 0.15s ease-in reverse;
}

@media (max-width: 768px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }
}
</style>
